import { jsonValue } from './jsonValue.js';
function jsonObject(constraints) {
    return typeof constraints === 'number' ? jsonValue({ maxDepth: constraints }) : jsonValue(constraints);
}
export { jsonObject };
